import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DataReportService } from '@app/_components/data-report/data-report.service';
import { PropertyService } from '@app/_components/property';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-vrbo-reservations',
    templateUrl: './vrbo-reservations.component.html',
    styleUrls: ['./vrbo-reservations.component.css'],
    standalone: false
})
export class VRBOReservationsComponent implements OnInit {
  formLoading = false;
  rows: Array<{
    createDate: string;
    shortTermRentalId: number;
    reservationId?: string;
    orderId?: number;
    queueStatus?: string;
    testResultDesc?: string;
  }> = [];

  // property filter
  properties: Array<{ shortTermRentalId: number; propertyCode: string }> = [];
  selectedShortTermRentalId?: number;

  constructor(
    private messageService: MessageService,
    private dataReportService: DataReportService,
    private propertyService: PropertyService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  get filteredRows() {
    if (!this.selectedShortTermRentalId) {
      return this.rows;
    }
    return this.rows.filter(r => Number(r.shortTermRentalId) === Number(this.selectedShortTermRentalId));
  }

  loadData(): void {
    this.formLoading = true;
    forkJoin([
      this.dataReportService.fetchVrboData('VrboReservationIncoming'),
      this.propertyService.findAllSummary()
    ]).subscribe(
      ([reportRes, propRes]: any[]) => {
        const reports: any[] = reportRes?.data?.qualityTests || reportRes?.data?.dataReports || [];
        this.rows = reports.map(r => ({
          createDate: r?.createDate,
          shortTermRentalId: Number(r?.shortTermRentalId),
          reservationId: r?.reservationId != null && r?.reservationId !== '' ? String(r.reservationId) : undefined,
          orderId: r?.orderId ? Number(r.orderId) : undefined,
          queueStatus: r?.queueStatus,
          testResultDesc: r?.testResultDesc
        }));

        const props: any[] = propRes?.data?.properties || [];
        this.properties = props.map(p => ({
          shortTermRentalId: p.shortTermRentalId,
          propertyCode: p.propertyCode
        }));
        this.formLoading = false;
      },
      (err: any) => {
        this.formLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.message || 'Failed to load reservations' });
      }
    );
  }
}


